import Image from "next/future/image";

export const clients = [
  { name: "Wright Research",               logo: "/companies/wright.webp",    url: "https://www.wrightresearch.in/" },
  { name: "Paterson Securities",           logo: "/companies/Paterson.webp",  url: "https://paterson.co.in/" },
  { name: "The Business Research Company", logo: "/companies/tbrc.avif",      url: "https://www.thebusinessresearchcompany.com" },
  { name: "The Indian Garage Co.",         logo: "/companies/tigc.svg",       url: "https://tigc.in" },
  { name: "GlobalFair",                    logo: "/companies/globalfair.png",  url: "https://www.myglobalfair.com" },
  { name: "C-DAC",                         logo: "/companies/cdac.png",       url: "https://www.cdac.in" },
  { name: "Fonepay",                       logo: "/companies/fonepay.webp",   url: "https://fonepay.com" },
];

export default function ClientsStrip({ clients: clientList = clients }) {
  return (
    <section className="px-8 md:px-[60px] py-10 bg-white border-t border-gray-100">
      <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-7">
        Clients we've worked with
      </p>
      <div className="flex flex-wrap items-center gap-8 md:gap-12">
        {clientList.map(c => (
          <a key={c.name} href={c.url} target="_blank" rel="noopener noreferrer" className="relative h-7 w-24 opacity-50 grayscale hover:opacity-80 hover:grayscale-0 transition-all">
            <Image
              src={c.logo}
              alt={c.name}
              fill
              className="object-contain"
              sizes="96px"
            />
          </a>
        ))}
      </div>
    </section>
  );
}
